module.exports = __webpack_public_path__ + "dfefa83f8968ddbfa3b7f2fb6e3e3efe.svg";